import createIcon from '../../createIcon';

/**
 * @component @name ForkLeft
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNDEgMTUuNTlMOSAxN0w1IDEzTDkgOUwxMC40MSAxMC40MUw4LjgzIDEyQzEwLjM0IDExLjY3IDEyLjU2IDEyLjA4IDE0IDEzLjM2VjYuODNMMTIuNDEgOC40MkwxMSA3TDE1IDNMMTkgN0wxNy41OSA4LjQxTDE2IDYuODNWMjFIMTRWMTdDMTMuMjcgMTQuNDIgMTAuOTMgMTMuNTMgOC44MyAxNEwxMC40MSAxNS41OVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ForkLeft = createIcon('ForkLeft', [
  [
    'path',
    {
      d: 'M10.41 15.59L9 17L5 13L9 9L10.41 10.41L8.83 12C10.34 11.67 12.56 12.08 14 13.36V6.83L12.41 8.42L11 7L15 3L19 7L17.59 8.41L16 6.83V21H14V17C13.27 14.42 10.93 13.53 8.83 14L10.41 15.59Z',
      key: '1jk5cn',
    },
  ],
]);

export default ForkLeft;
